import React from 'react'
import { useTheme } from 'styled-components';
import List from '../../common/List';

import { Container, Flex } from '../../styleguide/layout'

import { H1, P } from '../../styleguide/typography';

import AppStoreLinks from '../../common/AppStoreLinks';

// image
import heroImg from "../../../assets/heroImg.png"
import styledComponents from 'styled-components';

const Hero = () => {
  const theme = useTheme();

  return (
    <Container bg={theme.colors.lighterGray} height="130vh" heightMobile="135vh" margin="8rem 0 0 0" >
        <Flex items="center" height="100%" directionMobile="column" justifyMobile="center" gap="1rem" gapMobile="2.5rem">
            <Flex width="100%" direction="column" justify="center" order={2} gapMobile="0.7rem" >
                {/* hero heading */}
                <H1 maxWidth="710px" textTransform="uppercase">
                    Send MONEY <span style={{ color: theme.colors.secondary }}>ACROSS AFRICA</span> IN LESS THAN A MINUTE
                </H1>

                {/* hero list, used the flex box to add gap between */}
                <Flex width="100%" direction="column" gap="1rem" margin="1rem 0 0">
                    <List text="Distance is no barier" />
                    <List text="Use MULA Wallet for swift African transactions" />
                </Flex>

                {/* app icons */}
                <Flex width="100%" direction="column" gap="0" margin="2rem 0 0">
                    <P weight={theme.fontWeights.bold}>GET THE MULA FINANCE MOBILE WALLET:</P>
                    <AppStoreLinks />
                </Flex>
            </Flex>

            <HeroImg src={heroImg} alt="hero" />
        </Flex>
    </Container>
  )
}

export default Hero

const HeroImg = styledComponents.img`
    width: 100%;
    max-width: 550px;
    height: auto;
    border-radius: 8px;

    @media (max-width: 768px) {
        order: 1;
        max-width: 250px;
    }
`